// MARK: NPM
import React from "react";
import { createGlobalStyle, CSSObject } from "styled-components";
// MARK: Types
import StyleguideData from "types/globals/styleguide/styleguideData";
// MARK: Utilities
import Colors from "enums/colors";
import getColors from "../getColors";

import Styles from "enums/styles";
import CSSStyles from "enums/cssStyles";
import CSSColors from "enums/cssColors";
import createCSSStyle from "./createCSSStyle";
import createCSSColor from "./createCSSColor";


// MARK: Function
const CSS = (styleguide: StyleguideData) => {
  const css = [
    `body {
    margin: 0;
    font-family: "din-2014", -apple-system, BlinkMacSystemFont, "Segoe UI",
        "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
        "Helvetica Neue", sans-serif;
    color: ` +
      getColors(styleguide.colors, Colors.primary) +
      `;
    background-color: ` +
        getColors(styleguide.colors, Colors.background) +
      `;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: auto;
    width: 100vw;
    max-width: 100vw !important;
    overflow-x: hidden;
}

p {
    margin: 0;
}

#root {
    width: 100vw;
    max-width: 100vw !important;
}

code {
    font-family: "din-2014", -apple-system, BlinkMacSystemFont, "Segoe UI",
        "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
        "Helvetica Neue";
    font-display: swap;
}

a {
    text-decoration: underline;
    color: ` +
    getColors(styleguide.colors, Colors.secondary) +
      `;
}

a:hover {
    text-decoration: underline;
}

button {
    padding: 0;
    border: 0;
    background-color: transparent;
    display: flex;
}

dialog[open]:not(:focus-within) {
    background-color: ` +
    getColors(styleguide.colors, Colors.background) +
      `;
    transition: background-color 0.01s;
}

ul,
ol {
    list-style-type: none;
    font-family: "din-2014", -apple-system, BlinkMacSystemFont, "Segoe UI",
        "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
        "Helvetica Neue";
    font-display: swap;
}

* {
    box-sizing: border-box;
    font-family: "din-2014", -apple-system, BlinkMacSystemFont, "Segoe UI",
        "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
        "Helvetica Neue";
    font-display: swap;
}


`+createCSSStyle(styleguide, CSSStyles.medium, Styles.medium)+`
`+createCSSStyle(styleguide, CSSStyles.body, Styles.body)+`
`+createCSSStyle(styleguide, CSSStyles.bodyBold, Styles.bodyBold)+`
`+createCSSStyle(styleguide, CSSStyles.small, Styles.small)+`
`+createCSSStyle(styleguide, CSSStyles.large, Styles.large)+`
`+createCSSStyle(styleguide, CSSStyles.navigation, Styles.navigation)+`
`+createCSSStyle(styleguide, CSSStyles.sectionTitle, Styles.sectionTitle)+`
`+createCSSStyle(styleguide, CSSStyles.sectionSubtitle, Styles.sectionSubtitle)+`

`+createCSSColor(styleguide, CSSColors.accent, Colors.accent)+`
`+createCSSColor(styleguide, CSSColors.background, Colors.background)+`
`+createCSSColor(styleguide, CSSColors.error, Colors.error)+`
`+createCSSColor(styleguide, CSSColors.primary, Colors.primary)+`
`+createCSSColor(styleguide, CSSColors.secondary, Colors.secondary)+`
`+createCSSColor(styleguide, CSSColors.tertiary, Colors.tertiary)+`
`
  ];

  
  //@ts-ignore
  return createGlobalStyle(css);
};

export default CSS;
